import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'supply-by-day-component',
  templateUrl: './supply-by-day.component.html',
  styleUrls: ['./supply-by-day.component.scss']
})

export class SupplyByDayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
